import "./auth/mc-auth.js";
import { $, bindClick } from "./lib/dom.js";
import { bindHintTooltips } from "./lib/hints.js";
import { installSessionWatch } from "./lib/session-watch.js";
import { api, apiPublic, persistAuth, clearAuthSession, setEnv, LS } from "./api.js";
import { state, setAuthProviders } from "./state.js";
import {
  merchantStateFromMe,
  noteMerchantState,
  setMerchantStateHandlers,
} from "./lib/merchant-state.js";
import { buildNav, loadRbacMatrix } from "./nav.js";
import { initRouter, setRoute, routeFromHash } from "./router.js";
import {
  initAuthGate,
  loadAuth,
  showAuth,
  showConsole as showConsoleScreen,
  showLoginView,
  showRegisterView,
  isLoggedIn,
  applyPublicBaseFromProviders,
  consumePortalHandoff,
  consumeSsoTarget,
  paintSsoTargetHint,
  afterAuthSuccess,
} from "./auth-gate.js";
import {
  renderBadges,
  renderDistPortalButton,
  renderDistOpenButton,
  loadMallShopForOverview,
  renderChecklist,
  renderOnboardingStatus,
  updateAdminOpsUx,
  initPanelHandlers,
} from "./panels/index.js";

async function refreshAll() {
  const meRes = await api("GET", "/api/v1/merchant/me");
  if (meRes.ok) {
    state.me = meRes.data;
    if (window.McAuth) window.McAuth.setMe(state.me);
    if (meRes.data.merchant_id) {
      $("merchant-id").value = meRes.data.merchant_id;
      persistAuth();
    }
    if (meRes.data.console_person_id) {
      localStorage.setItem(LS.personId, meRes.data.console_person_id);
    }
    // 待审核/已驳回/已停用：进门就说清楚，不等面板逐个报错
    noteMerchantState(merchantStateFromMe(meRes.data));
  } else if (meRes.status === 401) {
    clearAuthSession();
    showAuth();
    const h = (window.location.hash || "").replace(/^#/, "");
    if (h === "register") showRegisterView(false);
    else showLoginView(false);
    return;
  }
  const obRes = await api("GET", "/api/v1/merchant/onboarding");
  if (obRes.ok) state.onboarding = obRes.data;
  await loadRbacMatrix();
  buildNav();
  renderBadges(state.me);
  renderDistPortalButton(); // 不 await：可选入口异步出现，不挡面板渲染
  renderDistOpenButton(); // 同上：概览「商家基本资料」里的开通/添加分销按钮
  loadMallShopForOverview(); // 店铺资料字段已迁至概览，随刷新填值（非平台店内部自跳过）
  renderChecklist(state.onboarding);
  renderOnboardingStatus(state.me, state.onboarding);
  updateAdminOpsUx();
  setRoute(routeFromHash());
  bindHintTooltips(document.getElementById("panel-overview"));
  bindHintTooltips(document.querySelector(".mcp-env-switch"));
}

async function ping() {
  /* backend status footer removed */
}

function showConsole(skipRefresh) {
  showConsoleScreen(skipRefresh);
}

async function bootstrap() {
  consumeSsoTarget();
  paintSsoTargetHint();
  consumePortalHandoff();
  loadAuth();
  const prov = await apiPublic("GET", "/api/v1/merchant/auth/providers");
  if (prov.ok) {
    setAuthProviders(prov.data);
    applyPublicBaseFromProviders();
  }

  if (isLoggedIn()) {
    const { ok } = await api("GET", "/api/v1/merchant/me");
    if (ok) {
      // 已登录且带分销 target → 直接回跳；否则进控制台
      await afterAuthSuccess();
      return;
    }
    clearAuthSession();
  }
  showAuth();
  const h = (window.location.hash || "").replace(/^#/, "");
  if (h === "register") showRegisterView(false);
  else showLoginView(false);
}

setMerchantStateHandlers({
  onGoRoute: (route) => setRoute(route),
  onLogout: () => {
    clearAuthSession();
    showAuth();
    showLoginView(false);
  },
});

initAuthGate({ refreshAll, ping });
initPanelHandlers(refreshAll);
initRouter({ showLoginView, showRegisterView });

bindClick("env-sandbox", () => setEnv("sandbox"));
bindClick("env-live", () => setEnv("live"));

const btnMenu = document.getElementById("mc-btn-menu");
const navBackdrop = document.getElementById("mc-nav-backdrop");
function setNavOpen(open) {
  document.body.classList.toggle("mc-nav-open", !!open);
  if (navBackdrop) navBackdrop.hidden = !open;
}
if (btnMenu) btnMenu.addEventListener("click", () => setNavOpen(true));
if (navBackdrop) navBackdrop.addEventListener("click", () => setNavOpen(false));
const sideNavEl = document.getElementById("side-nav");
if (sideNavEl) {
  sideNavEl.addEventListener("click", (e) => {
    if (e.target.closest("a, [data-route]")) setNavOpen(false);
  });
}

installSessionWatch();
bootstrap();
